import { api } from '@/shared/lib/api'
import { useQuery } from '@tanstack/react-query'

export const useKeywordHistories = (enabled: boolean = true) => {
    return useQuery({
        queryKey: ['search-keyword-histories'],
        queryFn: () => api.searchGlobal.keywordHistories(),
        enabled,
    })
}
